import { toast } from "sonner";
import { supabase } from "./supabaseClient";

// Frontend exposure of the EXISTING referral system only. The unique code lives on
// the signed-in user's Profiles.referral_code (already created by the backend); we
// never generate codes or award rewards here.
export async function getReferralCode() {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;
  const { data } = await supabase
    .from("Profiles")
    .select("referral_code")
    .eq("id", user.id)
    .maybeSingle();
  return data?.referral_code || null;
}

export function inviteUrl(code) {
  return `${window.location.origin}?ref=${encodeURIComponent(code)}`;
}

// Share the signed-in user's existing invite link via the native share sheet, with
// a clipboard-copy fallback when Web Share is unavailable.
export async function shareInvite() {
  const code = await getReferralCode();
  if (!code) {
    toast.error("Invite link unavailable. Please try again.");
    return;
  }
  const url = inviteUrl(code);
  const shareData = {
    title: "RoadRnr",
    text: "Join me on RoadRnr — invite a friend and you'll both get 3 free listings.",
    url,
  };
  if (navigator.share) {
    try {
      await navigator.share(shareData);
      return;
    } catch (e) {
      if (e && e.name === "AbortError") return; // user dismissed the share sheet
      // otherwise fall through to clipboard
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Invite link copied");
  } catch {
    toast.error("Could not copy invite link");
  }
}
